import styled from 'styled-components';

export default styled.div`
   position: relative;

   b {
      color: #111;
   }

   .integration-card {
      height: 100%;
   }

   .integration-card .card-body {
      display: flex;
      flex-direction: column;
      min-height: 220px;
   }

   .integration-card .card-actions {
      margin-top: auto;
   }

   .status-badge {
      display: inline-block;
      padding: 4px 12px;
      border-radius: 100px;
      font-size: 12px;
      font-weight: bold;
      text-transform: uppercase;
   }

   .status-badge.pending {
      background: #f9b955;
      color: #fff;
   }

   .status-badge.active,
   .status-badge.enabled {
      background: #56c470;
      color: #fff;
   }

   .status-badge.disabled {
      background: #dc3545;
      color: #fff;
   }

   .coming-soon {
      color: #6c757d;
      font-style: italic;
   }
`;
